import HandshqApp from '../handshq-app';

HandshqApp.recurlyService = {
  setup() {
    if (typeof recurly !== 'undefined') {
      HandshqApp.configureRecurly();
    }
    if ($('.payment-form').length) {
      HandshqApp.configurePayment();
    }
    if ($('.security-check-form').length === 1) {
      HandshqApp.authenticatePayment();
    }
  },
};

$(() => {
  HandshqApp.recurlyService.setup();
});
